import React from 'react';

const About = () => {
  return (
    <section className="section">
      <h2>À propos</h2>
      <div className="card" style={{ display: 'grid', gap: 12 }}>
        <img src="/assets/IMG_20250905_141324.jpg" alt="Usine Roka TC à Sousse" style={{ width: '100%', borderRadius: 12 }} />
        <p>Roka TC est un acteur de la fabrication textile de qualité. Notre usine située à Sousse emploie une main d'oeuvre tunisienne qualifiée.</p>
        <ul>
          <li>Spécialisation : tapis, couettes, sacs</li>
          <li>Services : OEM, étiquetage privé, contrôle qualité, logistique</li>
        </ul>
      </div>
    </section>
  );
};

export default About;
